import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as action from "../pagoDeducibleAuto-actions";
import "../pago-deducible.css";
import { makeStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import ModalError from "../modal-error/modal-error.cmpt";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { errorMultiple, errorCampoRequerido, handlePattern, validarDomicilio, 
	validarRfc, handleChangeDomicilio, handleChangeAndSetFiscales, blurInputsFiscales,
	blurInputsDomicilio, getClassNamePersona, getClassNamePersonaMoral, showErrorInput,
	handleCloseModalTimbrados, isValidForm} from "../utils";

const borderInput = "1px solid #AAC3EE";
const cadenaVacia = "";

const useStyles = makeStyles((theme) => ({
	pEstimado: {
		textAlign: "left",
		fontFamily: "Open Sans Regular, sans-serif !important",
		fontSize: "14px",
		color: "#33445F",
		fontStyle: "normal",
		fontWeight: 400,
		lineHeight: "24px",
		letterSpacing: "0.25px",
	},
	gnpEmitirCfdi: {
		padding: "90px 15px 10px 15px",
		color: "#33445F",
	},
	pSolicitud: {
		color: "#072F6E",
		fontSize: "16px",
		textAlign: "center",
		marginBottom: "34px",
	},
	paperEmitirCfdi: {
		padding: "2px 4px",
		display: "flex",
		alignItems: "center",
		width: "100%",
		marginBottom: "20px",
	},
	input: {
		marginLeft: theme.spacing(1),
		flex: 1,
	},
	iconButton: {
		padding: 10,
	},
	divider: {
		width: "100%",
		height: "1px",
		marginBottom: "7px",
	},
	divider2: {
		width: "100%",
		height: "1px",
		marginTop: "36px",
		marginBottom: "7px",
	},
	table: {
		width: "1214px",
		minWidth: 700,
	},
	footerModalTimbrado: {
		borderTop: "1px solid #E8EEF8",
		justifyContent: "flex-start",
		paddingBottom: "16px",
		paddingLeft: "24px",
		paddingTop: "16px",
	},
	borderBlue: {
		border: "1px solid #5488DE",
		boxSizing: "border-box",
		borderRadius: "4px",
	},
	inputStyles: {
		"& .MuiInputBase-input": {
			paddingBottom: "0px",
			paddingTop: "0px",
			marginBottom: "16px",
		},
		"& label": {
			color: "#33445F",
			fontSize: "16px",
		},
		"& label.Mui-focused": {
			color: "#647085",
		},
		"& .MuiInput-underline:after": {
			borderBottom: borderInput,
		},
		"& .MuiInput-underline:before": {
			borderBottom: borderInput,
		},
		"& .MuiInput-underline": {
			borderColor: "#AAC3EE",
			fontSize: "16px",
			color: "#0C2040",
		},
		"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
			borderBottom: "1px solid #FFB022",
		},
		"& .MuiInput-underline:hover:not(.Mui-disabled):after": {
			borderBottom: borderInput,
		},
		"& .MuiFormHelperText-root.Mui-error": {
			fontSize: "12px",
			color: "#CD5A59",
			backgroundColor: "#F9FAFC",
			margin: "0px",
		},
		"& .MuiFormHelperText-root": {
			margin: "0px",
			backgroundColor: "#F9FAFC",
		},
		"& .MuiFormLabel-root.Mui-error": {
			color: "#CD5A59",
		},
		"& .MuiTypography-body1": {
			fontSize: "16px",
			fontFamily: "Open Sans",
			fontStyle: "normal",
			fontWeight: 400,
			letterSpacing: "0.5px",
			lineHeight: "24px",
			color: "#33445F",
		},
	},
	inputGen: {
		width: "100%",
		backgroundColor: "#FFFFFF",
	},
	modalBodyTimbrado: {
		width: "412px",
		padding: "32px 32px 0px 32px",
		textAlign: "center",
	},
	inputRfc: {
		width: "100%",
		backgroundColor: "#FFFFFF",
		textTransform: "uppercase",
		"& .MuiInputBase-input": {
			textTransform: "uppercase !important",
		},
		"& .MuiFormHelperText-root.Mui-error": {
			textTransform: "none !important",
		},
	},
	labelCheckbox: {
		margin: "0px",
		"& .MuiTypography-body1": {
			fontSize: "16px",
			fontFamily: "Open Sans",
			fontStyle: "normal",
			fontWeight: 400,
			letterSpacing: "0.5px",
			lineHeight: "24px",
			color: "#33445F",
		},
		"& .MuiSvgIcon-root": {
			marginRight: "20px",
			width: "18px",
			height: "18px",
		},
	},
}));

const modalRegresar = (openModalRegresar, handleCloseRegresar)=>{
	return <ModalError
		iconButton={true}
		openModal={openModalRegresar}
		msjTitle="Cancelar operación"
		msjBody="¿Desea cancelar la operación?"
		withButtons={{
			actionButtons: true,
			msjButton1: "No, volver",
			msjButton2: "Si, cancelar",
		}}
		handleClose={(e) => handleCloseRegresar(e)}
	/>;
};

const modalNotificacion = (modalErrorTimbrado, setErrorTimbrado) =>{
	return <ModalError
		iconButton={true}
		openModal={modalErrorTimbrado}
		msjTitle="Servicio no disponible"
		msjBody="Intente nuevamente"
		handleClose={()=>setErrorTimbrado(false)}
	/>;
};

const modalRfcInvalido = (modalErrorRfc, handleCloseRfcInvalido) =>{
	return <ModalError
		iconButton={true}
		openModal={modalErrorRfc}
		msjTitle="RFC inválido"
		msjBody="No es posible generar factura con el RFC ingresado."
		msjBody2="¿Desea editar el RFC?"

		withButtons={{
			actionButtons: true,
			msjButton1: "Si",
			msjButton2: "No",
		}}
		handleClose={(e) => handleCloseRfcInvalido(e)}
	/>;
};

const modalTimbradoCfdi = (modalTimbrado, classes, handleCloseTimExito, handleCloseModalTimbrado) =>{
	return <Dialog
		disableEscapeKeyDown={true}
		disableBackdropClick
		open={modalTimbrado.openModalTimbrado}
		onClose={handleCloseModalTimbrado}
		aria-labelledby="alert-dialog-title"
		aria-describedby="alert-dialog-description"
	>
		<DialogContent className={classes.modalBodyTimbrado}>
			<p className="pTitleModalCvv"> Solicitud CFDI</p>
			<p className="pModalCvv">
        En un lapso máximo de 24 Hrs. estará disponible para su consulta y/o descarga.
			</p>
		</DialogContent>
		<DialogActions className={classes.footerModalTimbrado}>
			<Button className="buttonContinuarTimbrado" onClick={handleCloseTimExito}> Continuar </Button>
		</DialogActions>
	</Dialog>;
};

const inputRazonSocial = (labelRazonSocial, errorFiscales, classes, datosFiscales, blurInputFiscales, handleChange) =>{
	return <Grid item xs={12} sm={12} md={6} lg={6}>
		<TextField
			onBlur={blurInputFiscales}
			error={errorFiscales.nombreRazon}
			helperText={errorCampoRequerido(errorFiscales.nombreRazon)}
			onChange={handleChange}
			className={classes.inputGen}
			value={datosFiscales.nombreRazon}
			name="nombreRazon"
			id="nombreRazon"
			label={labelRazonSocial}
		/>
	</Grid>;
};

const inputRfc = (datosFiscales, errorFiscales, classes, blurInputFiscales, handleChange) =>{
	return <Grid item xs={12} sm={12} md={6} lg={6}>
		<TextField
			onBlur={blurInputFiscales}
			error={showErrorInput(errorFiscales.rfc, errorFiscales.rfcInvalido)}
			helperText={errorMultiple(
				"rfc",
				errorFiscales.rfc,
				errorFiscales.rfcInvalido
			)}
			onChange={handleChange}
			className={classes.inputRfc}
			value={datosFiscales.rfc}
			id="rfc"
			name="rfc"
			label="RFC"
		/>
	</Grid>;
};

const inputsFisica = (datosFiscales, errorFiscales, classes, blurInputFiscales, handleChange) =>{
	return <div style={{ width: "100%" }}>
		<Grid container item spacing={3} xs={12} sm={12} md={12} lg={12} style={{ marginBottom: "28px" }}>
			{inputRazonSocial("Nombre (s)", errorFiscales, classes, datosFiscales, blurInputFiscales, handleChange)}
			<Grid item xs={12} sm={12} md={6} lg={6}>
				<TextField
					onBlur={blurInputFiscales}
					error={errorFiscales.apellidoPaterno}
					helperText={errorCampoRequerido(
						errorFiscales.apellidoPaterno
					)}
					onChange={handleChange}
					className={classes.inputGen}
					value={datosFiscales.apellidoPaterno}
					id="apellidoPaterno"
					name="apellidoPaterno"
					label="Apellido Paterno"
				/>
			</Grid>
		</Grid>
		<Grid container item spacing={3} xs={12} sm={12} md={12} lg={12} style={{ marginBottom: "28px" }}>
			<Grid item xs={12} sm={12} md={6} lg={6}>
				<TextField
					onBlur={blurInputFiscales}
					error={errorFiscales.apellidoMaterno}
					helperText={errorCampoRequerido(
						errorFiscales.apellidoMaterno
					)}
					onChange={handleChange}
					className={classes.inputGen}
					value={datosFiscales.apellidoMaterno}
					id="apellidoMaterno"
					name="apellidoMaterno"
					label="Apellido Materno"
				/>
			</Grid>
			{inputRfc(datosFiscales, errorFiscales, classes, blurInputFiscales, handleChange)}
		</Grid>
	</div>;
};

const inputsMoral = (classes, errorFiscales, blurInputFiscales, handleChange, datosFiscales) =>{
	return <Grid container item spacing={3} xs={12} sm={12} md={12} lg={12} style={{ marginBottom: "28px" }}>
		{inputRazonSocial("Razón social", errorFiscales, classes, datosFiscales, blurInputFiscales, handleChange)}
		{inputRfc(datosFiscales, errorFiscales, classes, blurInputFiscales, handleChange)}
	</Grid>;
};

const datosDelTramite = (datosTramite) =>{
	return <Grid container>
		<Grid container item spacing={5} xs={12} sm={12} md={12} lg={12} style={{ marginBottom: "20px" }}>
			<Grid item xs={12} sm={12} md={6} lg={6}>
				<p className="tramiteTitle">Número de póliza</p>
				<p className="tramiteInfo">{datosTramite.numeroPoliza}</p>
			</Grid>
			<Grid item xs={12} sm={12} md={6} lg={6}>
				<p className="tramiteTitle">Número de Siniestro</p>
				<p className="tramiteInfo">{datosTramite.numeroSiniestro}</p>
			</Grid>
		</Grid>
		<Grid container item spacing={5} xs={12} sm={12} md={12} lg={12} style={{ marginBottom: "20px" }}>
			<Grid item xs={12} sm={12} md={6} lg={6}>
				<p className="tramiteTitle">Vehículo (Marca/Tipo)</p>
				<p className="tramiteInfo">{datosTramite.marcaVehiculo}</p>
			</Grid>
			<Grid item xs={12} sm={12} md={6} lg={6}>
				<p className="tramiteTitle">Modelo</p>
				<p className="tramiteInfo">{datosTramite.modelo}</p>
			</Grid>
		</Grid>
		<Grid container item spacing={5} xs={12} sm={12} md={12} lg={12} style={{ marginBottom: "20px" }}>
			<Grid item xs={12} sm={12} md={6} lg={6}>
				<p className="tramiteTitle">Placas</p>
				<p className="tramiteInfo">{datosTramite.placas}</p>
			</Grid>
		</Grid>
		<Grid container item spacing={5} xs={12} sm={12} md={12} lg={12} style={{ marginBottom: "20px" }}>
			<Grid item xs={12} sm={12} md={6} lg={6}>
				<p className="tramiteTitle">Concepto</p>
				<p className="tramiteInfo">{datosTramite.concepto}</p>
			</Grid>
			<Grid item xs={12} sm={12} md={6} lg={6}>
				<p className="tramiteTitle">Importe</p>
				<p className="tramiteInfo">${" "}{parseFloat(datosTramite.monto).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
			</Grid>
		</Grid>
		<Grid container item spacing={5} xs={12} sm={12} md={12} lg={12} style={{ marginBottom: "20px" }}>
			<Grid item xs={12} sm={12} md={6} lg={6}>
				<p className="tramiteTitle">Método de pago</p>
				<p className="tramiteInfo">{datosTramite.metodoPago}</p>
			</Grid>
			<Grid item xs={12} sm={12} md={6} lg={6}>
				<p className="tramiteTitle">Tarjeta</p>
				<p className="tramiteInfo">
					{datosTramite.numeroTarjeta && datosTramite.numeroTarjeta !== cadenaVacia ? datosTramite.numeroTarjeta : cadenaVacia}
				</p>
			</Grid>
		</Grid>
	</Grid>;
};

const formDatosFiscales = (dataFormDatosFiscaes) =>{
	const {datosFiscales, tipoPersona, domicilio, errorFiscales, errorDomicilio, classes, 
		handleChangePersona, blurInputFiscales, handleChange, blurInputDomicilio, handleChangeForm} = dataFormDatosFiscaes;
	return <Grid container className={classes.inputStyles}>
		<Grid container item xs={12} sm={12} md={12} lg={12}>
			<p className={classes.pEstimado}>
      Con el objetivo de expedir correctamente el comprobante fiscal, 
      es necesario validar nombre, dirección y RFC, en caso de no coincidir, puedes editarlos.
			</p>
		</Grid>
		<Divider className={classes.divider} orientation="horizontal" />
		<p className="encabezadoEmitir">DATOS FISCALES</p>
		<Grid container item xs={12} sm={12} md={12} lg={12} style={{ marginBottom: "16px", marginTop: "16px" }}>
			<FormControl component="fieldset" style={{ width: "100%" }}>
				<p className="tipoPersona">¿Qué tipo de persona eres?</p>
				<RadioGroup className="columnDirection" aria-label="gender" name="gender1" value={tipoPersona} onChange={handleChangePersona}>
					<Grid className={getClassNamePersona(tipoPersona)} item xs={12} sm={12} md={4} lg={4}>
						<FormControlLabel value="fisica" control={<Radio />} label="Persona Física" />
					</Grid>
					<Grid className={getClassNamePersonaMoral(tipoPersona)} item xs={12} sm={12} md={4} lg={4}>
						<FormControlLabel value="moral" control={<Radio />} label="Persona Moral" />
					</Grid>
				</RadioGroup>
			</FormControl>
		</Grid>

		{tipoPersona === "fisica" ? 
			inputsFisica(datosFiscales, errorFiscales, classes, blurInputFiscales, handleChange) : 
			inputsMoral(classes, errorFiscales, blurInputFiscales, handleChange, datosFiscales)}
		<Grid container item spacing={3} xs={12} sm={12} md={12} lg={12} style={{ marginBottom: "28px" }}>
			<Grid item xs={12} sm={12} md={6} lg={6}>
				<TextField
					onBlur={blurInputDomicilio}
					error={errorDomicilio.calle}
					helperText={errorCampoRequerido(errorDomicilio.calle)}
					onChange={(handleChangeForm)}
					className={classes.inputGen}
					value={domicilio.calle}
					name="calle"
					id="calle"
					label="Calle"
				/>
			</Grid>
			<Grid item xs={12} sm={12} md={6} lg={6}>
				<TextField
					onBlur={blurInputDomicilio}
					error={errorDomicilio.numero}
					helperText={errorCampoRequerido(errorDomicilio.numero)}
					onChange={handleChangeForm}
					className={classes.inputGen}
					value={domicilio.numero}
					id="numero"
					name="numero"
					label="Número exterior"
				/>
			</Grid>
		</Grid>
		<Grid container item spacing={3} xs={12} sm={12} md={12} lg={12} style={{ marginBottom: "28px" }}>
			<Grid item xs={12} sm={12} md={6} lg={6}>
				<TextField
					onChange={handleChangeForm}
					className={classes.inputGen}
					value={domicilio.interior}
					helperText=" "
					id="interior"
					name="interior"
					label="Número interior (Opcional)"
				/>
			</Grid>
			<Grid item xs={12} sm={12} md={6} lg={6}>
				<TextField
					onBlur={blurInputDomicilio}
					error={showErrorInput(errorDomicilio.codigoPostal, errorDomicilio.invalidCP)}
					helperText={errorMultiple(
						"codigoPostal",
						errorDomicilio.codigoPostal,
						errorDomicilio.invalidCP
					)}
					onChange={handleChangeForm}
					className={classes.inputGen}
					value={domicilio.codigoPostal}
					id="codigoPostal"
					name="codigoPostal"
					label="Código Postal"
				/>
			</Grid>
		</Grid>
		<Grid container item spacing={3} xs={12} sm={12} md={12} lg={12} style={{ marginBottom: "28px" }}>
			<Grid item xs={12} sm={12} md={6} lg={6}>
				<TextField
					onBlur={blurInputDomicilio}
					error={errorDomicilio.colonia}
					helperText={errorCampoRequerido(errorDomicilio.colonia)}
					onChange={handleChangeForm}
					className={classes.inputGen}
					value={domicilio.colonia}
					id="colonia"
					name="colonia"
					label="Colonia"
				/>
			</Grid>
			<Grid item xs={12} sm={12} md={6} lg={6}>
				<TextField
					onBlur={blurInputDomicilio}
					error={errorDomicilio.delegacionMunicipio}
					helperText={errorCampoRequerido(
						errorDomicilio.delegacionMunicipio
					)}
					onChange={handleChangeForm}
					className={classes.inputGen}
					value={domicilio.delegacionMunicipio}
					id="delegacionMunicipio"
					name="delegacionMunicipio"
					label="Alcaldía/Municipio"
				/>
			</Grid>
		</Grid>
		<Grid container item spacing={3} xs={12} sm={12} md={12} lg={12} style={{ marginBottom: "28px" }}>
			<Grid item xs={12} sm={12} md={6} lg={6}>
				<TextField
					onBlur={blurInputDomicilio}
					error={errorDomicilio.estado}
					helperText={errorCampoRequerido(errorDomicilio.estado)}
					onChange={handleChangeForm}
					className={classes.inputGen}
					value={domicilio.estado}
					id="estado"
					name="estado"
					label="Estado"
				/>
			</Grid>
		</Grid>
		<Grid container item spacing={3} xs={12} sm={12} md={12} lg={12}>
			<Grid item xs={12} sm={12} md={6} lg={6}>
				<TextField
					onBlur={blurInputDomicilio}
					error={showErrorInput(errorDomicilio.correoElectronico, errorDomicilio.formatCorreo)}
					helperText={errorMultiple(
						"correoElectronico",
						errorDomicilio.correoElectronico,
						errorDomicilio.formatCorreo
					)}
					onChange={handleChangeForm}
					className={classes.inputGen}
					value={domicilio.correoElectronico}
					id="correoElectronico"
					name="correoElectronico"
					label="Correo electrónico"
				/>
			</Grid>
			<Grid item xs={12} sm={12} md={6} lg={6}>
				<TextField
					onBlur={blurInputDomicilio}
					error={showErrorInput(errorDomicilio.telefono, errorDomicilio.invalidTelefono)}
					helperText={errorMultiple(
						"telefono",
						errorDomicilio.telefono,
						errorDomicilio.invalidTelefono
					)}
					onChange={handleChangeForm}
					className={classes.inputGen}
					value={domicilio.telefono}
					id="telefono"
					name="telefono"
					label="Teléfono"
				/>
			</Grid>
		</Grid>
		<Divider className={classes.divider2} orientation="horizontal" />
		<p className="encabezadoEmitir">DATOS DEL TRÁMITE</p>
	</Grid>;
};

const EmitirCfdi = (props) => {
	const dispatch = useDispatch();
	const classes = useStyles();
	const dataEmitir = useSelector(
		(state) => state.pagoDeducibleAutos.setEmitirCfdi
	);
	const global = useSelector((state) => state.global);
	const [cambiosError, setCambiosError] = useState(false);
	const [datosTramite, setDatosTramite] = useState({
		numPoliza: cadenaVacia,
		codSiniestro: cadenaVacia,
		marcaVehiculo: cadenaVacia,
		tipoVehiculo: cadenaVacia,
		modelo: cadenaVacia,
		placas: cadenaVacia,
		concepto: cadenaVacia,
		monto: cadenaVacia,
		metodoPago: cadenaVacia,
		numeroTarjeta: cadenaVacia,
	});
	const [datosFiscales, setDatosFiscales] = useState({
		estatusCfdi: cadenaVacia,
		idPago: cadenaVacia,
		isMoral: false,
		nombreRazon: cadenaVacia,
		apellidoMaterno: cadenaVacia,
		apellidoPaterno: cadenaVacia,
		rfc: cadenaVacia,
	});
	const [domicilio, setDomicilio] = useState({
		calle: cadenaVacia,
		numero: cadenaVacia,
		interior: cadenaVacia,
		colonia: cadenaVacia,
		codigoPostal: cadenaVacia,
		delegacionMunicipio: cadenaVacia,
		ciudad: cadenaVacia,
		estado: cadenaVacia,
		telefono: cadenaVacia,
		correoElectronico: cadenaVacia,
	});
	const [modalTimbrado, setModalTimbrado] = useState({
		openModalTimbrado: false,
	});
	const [modalErrorTimbrado, setErrorTimbrado] = useState(false);
	const [modalErrorRfc, setRfcInvalido] = useState(false);
	const [tipoPersona, setTipoPersona] = useState("fisica");
	const [errorFiscales, setErrorFiscales] = useState({
		nombreRazon: false,
		apellidoPaterno: false,
		apellidoMaterno: false,
		rfc: false,
		rfcInvalido: false,
	});
	const [errorDomicilio, setErrorDomicilio] = useState({
		calle: false,
		numero: false,
		colonia: false,
		codigoPostal: false,
		invalidCP: false,
		delegacionMunicipio: false,
		ciudad: false,
		estado: false,
		telefono: false,
		invalidTelefono: false,
		correoElectronico: false,
		formatCorreo: false,
	});
	const [openModalRegresar, setOpenModalRegresar] = useState(false);
	const handleChange = (event) => {
		handlePattern(event, tipoPersona);
		handleChangeAndSetFiscales(event, tipoPersona, datosFiscales, setDatosFiscales);
	};
	const handleCloseModalTimbrado = () => {
		const data = {datosFiscales, global, domicilio};
		handleCloseModalTimbrados(data, action, dispatch, setModalTimbrado, 
			setErrorTimbrado, setRfcInvalido);
	};

	const handleCloseRegresar = (e) => {
		if (e === "buttonIcon" || e === "button1") {
			setOpenModalRegresar(false);
		} else {
			setOpenModalRegresar(false);
			dispatch(action.setCfdi("Consulta"));
		}
	};

	const handleCloseTimExito = () => {
		dispatch(action.setCfdi("Consulta"));
	};

	const handleCloseRfcInvalido = (e) => {
		if (e === "buttonIcon" || e === "button1") {
			setRfcInvalido(false);
		} else {
			setRfcInvalido(false);
			dispatch(action.setCfdi("Consulta"));
		}
	};

	const handleChangeForm = (event) =>{
		handleChangeDomicilio(event, tipoPersona, domicilio, setDomicilio);
	};

	const handleChangePersona = (event) => {
		setErrorFiscales({...errorFiscales, nombreRazon: false, apellidoMaterno: false, apellidoPaterno: false, rfc: false,});
		setTipoPersona(event.target.value);
		setDatosFiscales({...datosFiscales, rfc: cadenaVacia, nombreRazon: cadenaVacia, apellidoMaterno: cadenaVacia, apellidoPaterno: cadenaVacia,});
	};

	const validarFiscales = (datosFiscalesResponse) => {
		if (datosFiscalesResponse.rfc !== cadenaVacia) {
			validarRfc(datosFiscalesResponse.rfc, errorFiscales, setErrorFiscales);
		}
	};

	useEffect(() => {
		setDatosFiscales({
			...dataEmitir.datosFiscales,
		});
		setDomicilio({
			...dataEmitir.datosFiscales.domicilio,
		});
		setDatosTramite({
			...dataEmitir.datosTramite,
		});
		setTipoPersona(dataEmitir.datosFiscales.isMoral ? "moral" : "fisica");
		validarFiscales(dataEmitir.datosFiscales);
		validarDomicilio(dataEmitir.datosFiscales.domicilio, errorDomicilio, setErrorDomicilio);
		dispatch(action.onLoading(false));
	}, [props]);

	const blurInputFiscales = (event) => {
		blurInputsFiscales(event, datosFiscales, tipoPersona, errorFiscales, setErrorFiscales);
	};

	const blurInputDomicilio = (event) => {
		blurInputsDomicilio(event, domicilio, errorDomicilio, setErrorDomicilio);
	};

	const handleChangeCheck = (e) => {
		setCambiosError(e.target.checked);
	};

	const dataFormDatosFiscaes = {datosFiscales, tipoPersona, domicilio, errorFiscales, errorDomicilio, classes, 
		handleChangePersona, blurInputFiscales, handleChange, blurInputDomicilio, handleChangeForm};
	return (
		<div className="container gnp-emitir-cfdi">
			<button className="buttonRegresarPago" onClick={() => setOpenModalRegresar(true)}>
				<a className="hooverRegresarPago" style={{ margin: "0px", display: "inline-block" }}>
					<ArrowBackIcon
						style={{
							marginRight: "8px",
							width: "18px",
							height: "18px",
							marginBottom: "-3px",
						}}
					></ArrowBackIcon>
					<span className="butRegresar">Regresar</span>
				</a>
			</button>
			<p className={classes.pSolicitud}>Solicitud de comprobante fiscal</p>
			<div className="">
				{formDatosFiscales(dataFormDatosFiscaes)}
				{datosDelTramite(datosTramite)}
			</div>
			<div className={classes.borderBlue}>
				<FormControlLabel className={classes.labelCheckbox}
					control={
						<Checkbox checked={cambiosError} onChange={handleChangeCheck} name="cambiosError" id="cambiosError" className="checBoxAcepto"/>
					}
					label="Confirmo que los datos fiscales proporcionados corresponden a los datos de alta en la Póliza o a la persona que efectuó el pago del deducible."
				/>
				<p className="pLabelCheck">
        La información es correcta y estoy de acuerdo con que, en caso de existir algún error u omisión en la información no será posible realizar cambios posteriores.
				</p>
			</div>
			<div className="sectionButton">
				<Button disabled={ isValidForm(tipoPersona, datosFiscales, domicilio, errorDomicilio, errorFiscales, cambiosError)} 
					className="buttonGenerarCfdi" onClick={handleCloseModalTimbrado}> Generar CFDI </Button>
			</div>
			{modalTimbradoCfdi(modalTimbrado, classes, handleCloseTimExito, handleCloseModalTimbrado)}
			{modalNotificacion(modalErrorTimbrado, setErrorTimbrado)}
			{modalRfcInvalido(modalErrorRfc, handleCloseRfcInvalido)}
			{modalRegresar(openModalRegresar, handleCloseRegresar)}
		</div>
	);
};

export default EmitirCfdi;


// WEBPACK FOOTER //
// ./src/pago-deducible-auto/emitir-cfdi/emitirCfdi.cmpt.js